/* eslint-disable import/extensions */

import {
  appraisalDashboardModule,
  budgetReviewModule,
  webBorrowerPortalService,
  webCommonService,
  webDrawService
} from "./mfe-remotes-config/remoteConfig.js";

window[webBorrowerPortalService.urlGlobalVariable] =
  webBorrowerPortalService.url;

window[webDrawService.urlGlobalVariable] = webDrawService.url;

window[webCommonService.urlGlobalVariable] = webCommonService.url;

window[appraisalDashboardModule.urlGlobalVariable] =
  appraisalDashboardModule.url;

window[budgetReviewModule.urlGlobalVariable] = budgetReviewModule.url;

import("./bootstrap.jsx");
